<div class="templateCharts" *ngIf="username; else elseBlock">
<div class="row" style="text-align: center; margin: auto;">
  <div class="col">
    <div class="card">
      <div class="card-body" style="margin: auto">
        <div class="row">
          <div class="col">
            <h1 class="card-title">Welcome to your user profile {{username}}!</h1>
            <br/>
          <h2 class="card-text">
            Please review your portfolio to date!
          </h2>
          </div>
          <div class="col" style="padding-top: 20px">
            <button (click)="logout()" class="btn btn--secondary">Log Out</button>
          </div>

        </div>
        
      </div>
    </div>
  </div>
</div>
<br />



<ul class="nav nav-pills mb-3 justify-content-center mobileTab" id="myTab" role="tablist" style="font-size: 2rem;">
  <!-- <li class="nav-item" role="presentation" class="navItems">
    <button class="nav-link active navText" id="feed-tab" data-bs-toggle="pill" data-bs-target="#feed" type="button" role="tab" aria-controls="feed" aria-selected="true"><i class="fa-solid fa-square-rss"></i> Feed</button>
  </li> -->
  <li class="nav-item" role="presentation" class="navItems">
    <button class="nav-link navText" id="stats-tab" data-bs-toggle="pill" data-bs-target="#stats" type="button" role="tab" aria-controls="stats" aria-selected="false"><i class="fa-solid fa-chart-simple"></i> Stats</button>
  </li>
  <li class="nav-item" role="presentation" class="navItems">
    <button class="nav-link navText" id="port-tab" data-bs-toggle="pill" data-bs-target="#port" type="button" role="tab" aria-controls="port" aria-selected="false"><i class="fa-solid fa-chart-pie"></i> Portfolio</button>
  </li>
</ul>
<div class="tab-content" id="myTabContent">
  <!-- <div class="tab-pane fade show active feedTab" id="feed" role="tabpanel" aria-labelledby="feed-tab">
    <div class="row" style="margin: auto">
      <div class="col">
        <div class="card">
          <div class="card-body" style="text-align: center; margin: auto;">
            <div class="card-title"></div>
            <div class="card-text" style="margin:auto;">
              <iframe width="900" height="1600" src="https://rss.app/embed/v1/wall/VKQizmR7fT4Q9q9B" frameborder="0"></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br/>
  </div> -->

  <div class="tab-pane fade show active" id="stats" role="tabpanel" aria-labelledby="stats-tab">
    <section class="section" #screen>
    <div class="shell shell--size-3">
        <br />
        <div class="row chart">
            <div class="col">
                <!-- <div class="chart__head hidden-xs"> -->
                <div class="chart__head">
                    <div class="chart__head-content">
                        <h6>eToro Analysis</h6>

                        <h5>Live Performance</h5>

                        <span>{{DynamUpd}}</span><br />
                        <!-- <span>Last Updated: {{updateRecent}}</span> -->
                    </div><!-- /.chart__head-content -->

                </div><!-- /.chart__head -->
            </div>
            <div *ngIf="!mobile" class="col legendGrad legendShadow" id="legend">
                <div id="legendItems">
                    <div class="row" style="margin-bottom: 10px;">
                        <div class="col">AGR - 2021 (Traded Gain)</div>
                        <div class="col"><span id="tGain"><span *ngIf="gPos">+</span>{{tGain}}%</span> </div>
                    </div>
                    <div class="row" style="margin-bottom: 10px;">
                        <div class="col">AGR - Since Launch</div>
                        <div class="col"><span id="tLaunch"><span *ngIf="lPos">+</span>{{tLaunch}}%</span></div>
                    </div>
                    <div class="row" style="margin-bottom: 10px;">
                        <div class="col">NSDQ100 Index</div>
                        <div class="col"><span id="tNSDQ"><span *ngIf="nPos">+</span>{{nsdqVal}}%</span></div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="mobile" class="row legendGrad legendShadow" id="legend">
            <div id="legendItems">
                <div class="row" style="margin-bottom: 10px;">
                    <div class="col">AGR - 2021 (Traded Gain)</div>
                    <div class="col-auto" style="padding-right: 1rem;"><span id="tGain"><span *ngIf="gPos">+</span>{{tGain}}%</span> </div>
                </div>
                <div class="row" style="margin-bottom: 10px;">
                    <div class="col">AGR - Since Launch</div>
                    <div class="col-auto" style="padding-right: 1rem;"><span id="tLaunch"><span *ngIf="lPos">+</span>{{tLaunch}}%</span></div>
                </div>
                <div class="row" style="margin-bottom: 10px;">
                    <div class="col">NSDQ100 Index</div>
                    <div class="col-auto" style="padding-right: 1rem;"><span id="tNSDQ"><span *ngIf="nPos">+</span>{{nsdqVal}}%</span></div>
                </div>
            </div>
        </div>
        <br />
        <div class="row chart">
            <div class="chart__body" class="wow fadeInRight" data-wow-delay=".5s" id="chart">
                <div id="container" style="text-align:center;">
                </div><!-- /.chart__body -->
            </div>
        </div>
    </div><!-- /.shell -->
</section>
    <br />
    
    <div class="row" style="margin: auto">
      <div class="col avgMarg">
        <div style="text-align: center; margin: auto;">
          <div style="margin:auto;">
            <section class="section" style="padding-bottom: 0rem" id="about">
              <div class="shell shell--size-3">
                <div class="section__head">
                  <h6>Algorithm</h6>
      
                  <h2>Risk Score</h2>
                </div><!-- /.section__head -->
              </div>
            </section>
            <div id="containerRisk" class="riskCon" style="text-align: center; margin: auto"></div>
          </div>
        </div>
        <p style="font-size: large">Average Risk Score: {{riskText}}</p>
      </div>
    </div>
    <br />

    <br/>
  </div>
  <div class="tab-pane fade" id="port" role="tabpanel" aria-labelledby="port-tab">
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-body" style="text-align: center; margin: auto; font-size: large">
            <div class="card-title"><b>Live Portfolio</b></div>
            This is your live portfolio, and will update frequently.
            <span class="card-text"  class="table table-striped">
              <div class="portfolioTab">
                <thead>
                <tr>
                  <th class="portHeading">Name</th>
                  <th class="portHeading">Investment %</th>
                  <th class="portHeading">Net Profit</th>
                  <th class="portHeading">Open Rate</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let position of portfolioPositions">
                  <td class="portHeading portLeft" style="text-align: left;">{{position.positionId}}</td>
                  <td class="portHeading">{{position.investmentPct}}</td>
                  <td class="portHeading">{{position.netProfit}}</td>
                  <td class="portHeading">{{position.openRate}}</td>
                </tr>
              </tbody>
            </div>
              
          </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</div>
<ng-template #elseBlock>
  <div class="err">
    <h1>Please login or register!</h1>
  </div>
</ng-template>